export default "__VITE_ASSET__c5wcCGOn__"